import React from 'react'

export interface IRoute {
  path: string
  rootPath?: string
  component?: React.ReactNode
  children?: Array<IRoute>
  icon?: string
  name: ERouteName
  color?: ERouteGroupColor
  hasAccess?: boolean
  hideOnSidebar?: boolean
  hideOnMainPage?: boolean
}

export enum ERouteGroupColor {
  Primary = 'primary',
  Blue = 'blue',
  Orange = 'orange',
  Violet = 'violet',
  Red = 'red',
  Amber = 'amber'
}

export enum ERouteName {
  AccountManagementGroup = 'account-management',
  AccountManagement_ClinicInfo = 'clinic-info',
  AccountManagement_Role = 'role-management',
  AccountManagement_User = 'user-management',
  AccountManagement_SystemSetting = 'system-setting',
  AccountManagement_SystemSettingDetail = 'system-setting-detail',
  AccountManagement_SystemSettingAdd = 'system-setting-add',
  MenuManagementGroup = 'menu-management',
  MenuManagement_GroupService = 'group-service',
  MenuManagement_SubService = 'service',
  MenuManagement_TimeSetting = 'time-setting',
  MenuManagement_Doctor = 'doctor',
  MenuManagement_ClinicRoomSetting = 'clinic-room-setting',
  MenuManagement_Template = 'template',
  PatientManagementGroup = 'patient-management',
  PatientManagement_Dashboard = 'dashboard',
  PatientManagement_Booking = 'booking',
  PatientManagement_Patient = 'patient',
  PatientManagement_PatientDetail = 'patientDetail',
  PatientManagement_Receive = 'receive',
  PatientManagement_ReceiveAdd = 'receive-add',
  PatientManagement_ReceiveDetail = 'receive-detail',
  PatientManagement_Payment = 'payment',
  PatientManagement_PaymentDetail = 'payment-detail',
  PatientManagement_Prescription = 'prescription',
  PatientManagement_Transaction = 'transaction',
  ExamGroup = 'exam-management',
  ExamGroup_Exam = 'examination',
  ExamGroup_Exam_Patient = 'examination-patient',
  ExamGroup_Supersonic = 'supersonic',
  ExamGroup_Subclinical = 'subclinical',
  RepoManagementGroup = 'repo-management',
  RepoManagement_Inventory = 'repo-inventory',
  RepoManagement_Import = 'repo-import',
  RepoManagement_Export = 'repo-export',
  HelpGroup = 'help',
  HelpGroupUserManual = 'user-manual',
  HelpGroupContact = 'contact'
}
